import { render, staticRenderFns } from "./PickupData.vue?vue&type=template&id=9e16fd52"
import script from "./PickupData.vue?vue&type=script&lang=js"
export * from "./PickupData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports